import {
    ADD_PERMISSION_TO_TEAM,
    ADD_PERMISSION_TO_TEAM_FAIL,
    ADD_PERMISSION_TO_TEAM_SUCCESS
} from './actionTypes';

const initialState = {
    teamId: null,
    updatedPermissions: null,
    addedPermission: null,
    error: null,
    loading: false,
    loaded: false
};

export function addTeamPermissionReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_PERMISSION_TO_TEAM:
            return {
                ...initialState,
                teamId: action.payload.teamId,
                updatedPermissions: action.payload.permission,
                loading: true
            };
        case ADD_PERMISSION_TO_TEAM_SUCCESS:
            return {
                ...state,
                addedPermission: action.payload,
                loaded: true,
                loading: false
            };
        case ADD_PERMISSION_TO_TEAM_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        }
        default:
            return state;
    }
}
